// Section card for the v2 dashboard — a titled white card with an icon, a title, optional
// right-aligned controls (range / role segments), and content. Matches the section frames in
// the Figma design (Shipments / Reservation / Supplier notifications).
import React, { ReactNode } from 'react';
import DashboardInfoTooltip from './DashboardInfoTooltip.tsx';

interface DashboardSectionProps {
  title: ReactNode;
  icon?: ReactNode;
  controls?: ReactNode;
  // Optional info tooltip beside the title (icon shown only when provided).
  titleTooltip?: ReactNode;
  children: ReactNode;
}

const DashboardSection: React.FC<DashboardSectionProps> = ({ title, icon, controls, titleTooltip, children }) => {
  return (
    <section className="flex flex-col gap-4">
      <header className="flex flex-row items-center justify-between gap-4 flex-wrap">
        <div className="flex flex-row items-center gap-2 text-content-primary">
          {icon && <span className="inline-flex items-center text-content-primary [&_svg]:w-5 [&_svg]:h-5">{icon}</span>}
          <h2 className="text-xl font-medium">{title}</h2>
          <DashboardInfoTooltip content={titleTooltip} />
        </div>
        {controls && <div className="flex flex-row items-center gap-3 flex-wrap">{controls}</div>}
      </header>
      {children}
    </section>
  );
};

export default DashboardSection;